import { render, staticRenderFns } from "./InProgressApplicationList.vue?vue&type=template&id=28c88c6a&lang=html&"
import script from "./InProgressApplicationList.vue?vue&type=script&lang=js&"
export * from "./InProgressApplicationList.vue?vue&type=script&lang=js&"
import style0 from "./InProgressApplicationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports